export const base_URL =
  "https://ko-trading-game-backed-api-gkmkh.ondigitalocean.app";
